export default __webpack_public_path__ + "static/media/facebook.476c2f8d.svg";